export const getCookie = function (name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift() ?? "";
  return "";
};

export const cookieExists = function (name: string) {
  return document.cookie.includes(name);
};

export const setCookie = function (
  name: string,
  value: string,
  expirationSeconds: number
) {
  const date = new Date();
  date.setTime(date.getTime() + expirationSeconds * 1000);
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
};

export const deleteCookie = function (name: string) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
